import { createMetrics } from "react-metrics";

import { _addToCart, _removeFromCart, _compare, _pageView, _sort, _variantsSelection, _productClick, parseMetricParams } from './track-params';
import ActionTypes from './action-types';
import { Helpers } from '../core/src/helpers';
import MetricsConfig from './metrics.config';
import { ADD_REDIRECT } from "../page/page-actions";

const metrics = createMetrics(MetricsConfig);

const CUR = 'USD'; // currency
const CATEGORY_MAP = {
	"accessories": "accessories",
	"carepack": "care packs",
	"desktops": "desktops",
	"monitor": "monitor",
	"notebooks": "laptops",
	"printers": "printers",
	"supplies": "ink, tonerpaper",
	"tablets": "laptops",
};
const XSELL_TYPE_MAP = {
	"tabs": "3up-tabs",
	"sixup": "6up",
}
const SMB_SUBCAT = {
	"desktopcommercial": 1,
	"notebookcommercial": 1,
};

const TEMPLATE_KEY_PAGE_NAMES = {
	pageNameL5:{
		'dlp': 'dynamic',
		'blog': 'article',
		'blog-list': 'list'
	},
	pageNameL6:{
		'dlp': 'dlp',
		'blog': 'tech-takes',
		'blog-list': 'tech-takes',
		'filters': 'plp',
		'sale-v3': 'slp',
		'gift-guide': 'gift-guide'
	}
}
let PAGE = {RECEIVED: false};
let USER = {RECEIVED: false};
let PRODUCTS;
let prev_location = '';
let pg_redirect_location = null; // used to prevent double page views when making a PG redirect

let prev_pdp = '';
const pdpPageView = (product, getState) => {
	let params = {};
	let { 
		name,
		listPrice: price,
		attributes,
		sku: id,
		slug: pageName,
		isSmb='No',
		prdClass,
		variantSelected,
		variants=[],
		pdpConfig={}
	} = product;

	// prevents double page view when navigating between pdps (v2->v1, v2->v2, v1->v2, v2->v2)
	if(prev_pdp === id){
		return;
	}
	prev_pdp = id;

	let {
		facet_subbrand,
		pm_producttype,
		subbrandname,
		plcode: category,
		product_line,
		"3211896": tppBrand,
	} = attributes || {};

	let { analytics, templateKey } = ( product && product.pdpConfig ) || {}
	let { pageNameL5, pageNameL6, pageNameL7, businessUnit: pdpBusinessUnit } = analytics || {};

	// get brand name
	let brand = facet_subbrand || subbrandname || tppBrand || pm_producttype;
	let [pageFunction] = [prdClass !== 'MMD' ? 'pdp' : 'mmd'];

	if(prdClass === 'PRT' && variants.length > 0 && !variantSelected){
		return;
	}

	let analyticsCategory = category || product_line;
	let pageCategory = CATEGORY_MAP[Helpers.getMappedCat(analyticsCategory)] || Helpers.getMappedCat(analyticsCategory);
	let businessUnit = isSmb === 'Yes' ? 'business' : 'consumer';
	
	PAGE.pageNameL5   = !!pageNameL5 	  ? pageNameL5 		: pageCategory;
	PAGE.pageNameL6   = !!pageNameL6 	  ? pageNameL6 		: pageFunction;
	PAGE.pageNameL7   = !!pageNameL7 	  ? pageNameL7 		: pageName;
	PAGE.businessUnit = !!pdpBusinessUnit ? pdpBusinessUnit : businessUnit;
	PAGE.templateKey = templateKey;
	PAGE.RECEIVED = true;

	// convert price to string
	price += '';

	PRODUCTS = [{
		id,
		name,
		price,
		category,
		brand,
	}];

	if(USER.RECEIVED){
		// set up page params
		params = _pageView(PAGE, USER, PRODUCTS, getState());
		// track page view
		metrics.api.pageView(params);
	}
}

export default function metricsMiddleware({getState}) {
	return next => action => {
		const returnValue = next(action);
		let params = {};
		switch (action.type) {
			case ADD_REDIRECT: {
				/* Intercept redirect actions to prevent double pageviews. The only time isPGRedirect is true is when
				   a product group tab that doesn't exist is visited. In this case, the only page view event triggered is in
				   RECEIVE_SLUG_INFO, and the extra page view in LOCATION_CHANGE is prevented 
				   (pg_redirect_location===location condition check in LOCATION_CHANGE makes sure the extra page view doesn't occur)
				*/
				try{
					let { destination, isPGRedirect } = action;
					pg_redirect_location = isPGRedirect ? destination : null;
				}catch(e){}
				break;
			}
			case ActionTypes.ADD_TO_CART: {
				// init product variable
				let {product={}, addOns, qty, cartData={}, baseProductSku, xsellType,metricParams } = action;
				let xsellMethod = XSELL_TYPE_MAP[xsellType] || xsellType;

				// convert to empty array if null
				addOns = addOns || [];

				// get cart data
				const products = product instanceof Array ? product : [{product, qty}, ...addOns];

				product = products.reduce((prds, cur) => {
					// update multi products format
					cur = cur.product ? cur : {product: cur, qty};
					let { product: {
									name,
									listPrice: price,
									sku: id,
									attributes
								},
								qty: quantity } = cur;
					let { facet_subbrand, pm_producttype, subbrandname, plcode: category, "3211896": tppBrand } = attributes || {};
					// get brand name
					let brand = facet_subbrand || subbrandname || tppBrand || pm_producttype;
					// convert price to string
					price += '';

					prds.push({
						brand,
						category,
						id,
						name,
						price,
						quantity,
						xsellProdInfo: baseProductSku,
						xsellMethod
					});

					return prds;
				}, []);
				// set add to cart params
				params = _addToCart(product, CUR, cartData.id, metricParams);

				// set up pageLoad analytic call
				metrics.api.pageView(params);
				break;
			}
			case ActionTypes.REMOVE_FROM_CART: {
				// TODO: need to find a way to pass category on cart remove
				// get cart data
				let { product: {name, amt: {uPrice: price}, pNum : id}, qty: quantity } = action;

				// convert price to string
				price += '';

				// set up product
				let products = [{
					id,
					name,
					price,
					quantity,
				}];

				// set remove from cart params
				params = _removeFromCart(products, CUR)

				// set up pageLoad analytic call

				metrics.api.pageView(params);
				break;
			}
			// ignore for now since users have to re-initiate the page when they log-in (Move from APP > ETR > APP).
			// case ActionTypes.FETCH_UTILITY:{
			// 	USER.RECEIVED = false;

			// 	break;
			// }
			case ActionTypes.RECEIVE_UTILITY:{
				// track on first time user data is loaded
				if (USER.RECEIVED) {return; }
				
				// get users data
				let {personData: {agentLogonId, userTier, userType, loyalty, pStoreID}} = action.utilityInfo.profileData;

				// set users data
				USER.logged_in = (!!userType && userType.toLowerCase()) === 'r' ? true : false;
				USER.tier = !!agentLogonId ? 'call center' : (USER.logged_in ? 'registered' : 'gen');
				USER.tier = USER.tier === 'registered' && pStoreID
							? `pri-${pStoreID}`
							: USER.tier;
				USER.isCallCenter = !!agentLogonId ? 'wcs call center' : 'wcs web';
				USER.RECEIVED = true;
				
				if(PAGE.RECEIVED){
					// set up page params
					params = _pageView(PAGE, USER, PRODUCTS, getState());

					// track page view

					metrics.api.pageView(params);
				}
				break;
			}
			/* TEMP: seems like no tracking event is firing on select <option> elements. My assumption is select is firing onChange event,
			   and not a click event; therefore, not triggering react-metrics.
			   TODO: Build a dropdown component using divs and anchor tags. PROS: event handling, CSS style modification. CONS: lost select api, and event handling. */
			case ActionTypes.TRACK_SORT:
			case ActionTypes.SORT_PRODUCTS: {
				let {sortValue} = action;
				params = _sort(sortValue);


				metrics.api.pageView(params);

				break;
			}
			/* There are multiable elements/components that trigger the compare modal, couldn't think of a way to manage track attributes
			   for all componanets, rather than subscriping to MODAL_TOGGLE and fire tracking values when compare modal opens */
			case ActionTypes.TOGGLE_COMPARE_MODAL:{
				let {toggle} = action;
				toggle && (params = _compare(getState().compare.products)) && metrics.api.pageView(params);

				break;
			}
			case ActionTypes.FETCH_SLUG_INFO:{
				PAGE.RECEIVED = false;

				break;
			}
			case ActionTypes.TRACK_PAGE_VIEW:
			case ActionTypes.RECEIVE_SLUG_INFO:{
				let { vanityUrl, urlParams = {}, analytics, templateKey, components } = action.slugInfo;

				// reset prev_pdp when going to different page type. this prevents double page views on pdps
				if(templateKey && !/pdp/.test(templateKey)){
					prev_pdp = '';
				}
				// for pdp-v2 tracking
				if(templateKey === 'pdp-v2'){
					let {product} = components || {};
					pdpPageView(product, getState);
					break;
				}

				let [ directory, pageName ] = vanityUrl.split('/');

				let [type, category, businessUnit] = [
					vanityUrl === 'plp/accessories' ? 'accessories' : 'static', 
					'landing', 
					'consumer'
				]; // move to vanity/merch ui ?

				let {  pageNameL5, 
					   pageNameL6, 
					   pageNameL7, 
					   businessUnit: analyticsBusinessUnit } = analytics || {}
				
				let template = directory === 'tech-takes' && !templateKey ? 'blog-list' : templateKey;
				type 	 = TEMPLATE_KEY_PAGE_NAMES.pageNameL5[template] || type;
				category = TEMPLATE_KEY_PAGE_NAMES.pageNameL6[template] || category;

				PAGE.pageNameL5 = !!pageNameL5 ? pageNameL5 : type;
				PAGE.pageNameL6 = !!pageNameL6 ? pageNameL6 : category;
				PAGE.pageNameL7 = !!pageNameL7 ? pageNameL7 : (pageName || directory);
				// PAGE.pageNameL8
				PAGE.businessUnit = !!analyticsBusinessUnit ? analyticsBusinessUnit : businessUnit;
				PAGE.urlParams = urlParams;
				PAGE.templateKey = templateKey;
				PAGE.RECEIVED = true;

				if(USER.RECEIVED){
					// set up page params
					params = _pageView(PAGE, USER, undefined, getState());
					// track page view
					metrics.api.pageView(params);
				}
				break;
			}
			case ActionTypes.TRACK_PDP_PAGE_VIEW:
			case ActionTypes.RECEIVE_VARIANT_INFO:
			case ActionTypes.RECEIVE_PDP_INFO: {
				let { pdpInfo, variantInfo } = action;
				let product = pdpInfo || variantInfo;
				pdpPageView(product, getState);
				break;
			}
			case ActionTypes.LOCATION_CHANGE:{
 				let { location = {} } = action.payload;
 				let { pathname: next_location = ""} = location;
 				let { directory: prev_directory, slug: prev_slug, filters: prev_filters = {} } = Helpers.parseUrl(prev_location); 
 				let { directory: next_directory, slug: next_slug, filters: next_filters = {} } = Helpers.parseUrl(next_location); 
 				let { pg: prev_pg } = prev_filters;
 				let { pg: next_pg } = next_filters;

 				let TRACK_LOCATION_CHANGE = (next_directory === prev_directory) && (next_slug === prev_slug) && (next_pg !== prev_pg);
				
				// prevent extra page view event due to going to a product group tab that doesn't exist
				// in this case, the only page view triggered is for the root url, in RECEIVE_SLUG_INFO.
				let preventPageView = pg_redirect_location === next_location || (typeof next_location === 'string' && /^\/us\-en\/shop\/pdp/.test(next_location));

	  			if (PAGE.RECEIVED && USER.RECEIVED && TRACK_LOCATION_CHANGE && !preventPageView) {
 					// append tab name on location change
 					PAGE.pageNameL7 = `${next_slug}:productTab:${next_pg}`;

 					// set up page params
 					params = _pageView(PAGE, USER, undefined, getState());
 
 					// track page view
 					metrics.api.pageView(params);
				 };

				// reset the product group redirect location whenever the location changes.
				pg_redirect_location = null;

 				// prevent double tracking when url params change
 				prev_location = next_location;
 
 				break;
 			}

 			case ActionTypes.RECEIVE_REORDER_INFO: {
				const { orderDate, source } = action;
				const [pageFunction] = ['reorder'];
				
				PAGE.pageNameL5 = pageFunction;
				PAGE.templateKey = 'reorder';

				if (source){
					//source could be loi|web|pdp, loi|web|clp, or loi|email|marketing
					const [srcValue = 'reorder'] = source;
					let [id="", , srcPageType=""] = srcValue.toLowerCase().split('|');
					PAGE.pageNameL6 = `${id}-${srcPageType}`
				} else {
					try {
						// check if reorderInfo has valid content
						PAGE.pageNameL6 = !orderDate && !source ? '' : 'reorder';
					} catch (e) {
						// log
						// reorderInfo had wrong data type
					}
				}
				
				PAGE.RECEIVED = true;

				
				if(USER.RECEIVED){
					// set up page params
					params = _pageView(PAGE, USER, PRODUCTS, getState());

					// track page view
					metrics.api.pageView(params);
				}
 				break;
 			}
			// when MetricsElement can't be used for custom analytics
			case ActionTypes.TRACK_CUSTOM_METRIC: {
				try{
					let { eventName, params } = action.payload;
					metrics.api.track(eventName, params);
				}catch(e){}
			}
		}

		return returnValue;
	};
}
